import {schema as Schema} from 'normalizr';

export const poolListEntity = new Schema.Entity('byId', {}, {idAttribute: 'id'});
export const poolListSchema = new Schema.Array(poolListEntity);
